/* --------------------------------  CHECK BROWSER  09.04.2018 ------------------------- */
(function (jQuery) {
  jQuery.gfCheckBrowser = function (element, options) {
    const defaults = {};
    const _this = this;
    const $element = jQuery(element);

    const _templateCheckName =
      '<div class="checkBrowser_body"><svg data-action="close"><svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d="M8.9,7.9l4.1-4.1c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L8,7L3.9,2.9c-0.2-0.2-0.6-0.2-0.9,0c-0.2,0.2-0.2,0.6,0,0.9l4.1,4.1l-4.1,4.1c-0.2,0.2-0.2,0.6,0,0.9C3.2,13,3.3,13,3.5,13s0.3-0.1,0.4-0.2L8,8.8l4.1,4.1c0.1,0.1,0.3,0.2,0.4,0.2s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.6,0-0.9L8.9,7.9z" /></svg></svg><img src="images/gempages_plus_chrome.png" alt="#" /><h3>Get Chrome Browser</h3><p>Download and install Chrome Browser to have best experience with Gempages page builder.</p><a href="https://www.google.com/intl/en_en/chrome/" target="_blank">Install Google Chrome</a></div>';
    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      // check version
      _this.versionBrowser();
    };

    this.versionBrowser = function () {
      // Firefox Seamonkey Chrome Chromium Safari Opera Internet Explorer ;
      if (navigator.userAgent.indexOf('Chrome') == -1) {
        if (localStorage.getItem('check-browser-name') != 'hide') {
          const $popupCheckBrowser = $element;
          $popupCheckBrowser.addClass('show');
          $popupCheckBrowser.html(_templateCheckName);

          $popupCheckBrowser
            .find('svg[data-action="close"]')
            .off()
            .on('click', function () {
              $popupCheckBrowser.removeClass('show');
              localStorage.setItem('check-browser-name', 'hide');
            });
        }
      }
    };

    this.init();
  };
  jQuery.fn.gfCheckBrowser = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfcheckbrowser')) {
        const plugin = new jQuery.gfCheckBrowser(this, options);
        jQuery(this).data('gfcheckbrowser', plugin);
      }
    });
  };
})(jQuery);
